// Ported from design/project/App53-DailyLimit.dc.html, then wired: a battle would go over the player's own daily
// stake limit. Shown when a search or challenge is refused for it.
import { useEffect, useState } from "react";
import { api } from "../api.js";
import { useTicker } from "../game.js";
import { go } from "../router.js";
import type { LimitsView } from "./App58-PlayLimits.js";

export function App53_DailyLimit() {
  const [view, setView] = useState<LimitsView | null>(null);
  useEffect(() => void api<LimitsView>("/v1/limits").then(setView).catch(() => {}), []);
  useTicker(1000);
  const d = view?.daily;
  const left = d ? Math.max(0, d.resetsAt - Date.now()) : 0;
  const clock = [Math.floor(left / 3_600_000), Math.floor((left % 3_600_000) / 60_000), Math.floor((left % 60_000) / 1000)].map((n) => String(n).padStart(2, "0")).join(":");
  const pct = d?.limit ? Math.min(1, Number(d.staked) / d.limit) : 1;
  const ring = 2 * Math.PI * 72;
  return (
    <div className="screen">
      <div className="orbR" aria-hidden="true" style={{ top: "40px", right: "-200px", width: "460px", height: "460px" }}></div>
      <div className="pad squeeze" style={{ height: "100%", paddingBottom: "calc(var(--dd-safe-bottom, 0px) + 20px)" }}>
        <div className="top"><span className="chip chipN">RESPONSIBLE PLAY</span></div>
        <div style={{ marginTop: "10px", alignSelf: "center", position: "relative", width: "min(170px, 26dvh)", aspectRatio: "1", flexShrink: 0 }}>
          <svg width="100%" height="100%" viewBox="0 0 170 170" aria-hidden="true"><circle cx="85" cy="85" r="72" fill="none" stroke="#30363D" strokeWidth="12"></circle><circle cx="85" cy="85" r="72" fill="none" stroke="#FF3366" strokeWidth="12" strokeLinecap="round" strokeDasharray={`${ring * pct} ${ring}`} transform="rotate(-90 85 85)"></circle></svg>
          <div style={{ position: "absolute", inset: "0", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
            <span className="mono" style={{ fontWeight: "800", fontSize: "30px" }}>{d ? Number(d.staked).toLocaleString("en-US", { maximumFractionDigits: 2 }) : "..."}</span>
            <span className="muted" style={{ fontSize: "12px" }}>of {d?.limit ?? "..."} USDT</span>
          </div>
        </div>
        <h1 className="h1" style={{ marginTop: "16px", textAlign: "center" }}>Daily limit reached</h1>
        <p className="muted" style={{ margin: "8px 6px 0", textAlign: "center", fontSize: "14px", lineHeight: "21px" }}>You set a limit of {d?.limit ?? "..."} USDT staked per day. Good call sticking to it.</p>
        <div className="g" style={{ marginTop: "18px", borderRadius: "20px", padding: "14px", display: "flex", flexDirection: "column", alignItems: "center", gap: "4px", flexShrink: 0 }}>
          <span className="lbl" style={{ fontSize: "10px" }}>RESETS IN</span>
          <span className="mono" role="timer" style={{ fontWeight: "800", fontSize: "32px" }}>{clock}</span>
          <span className="muted" style={{ fontSize: "12px" }}>At 00:00 WAT</span>
        </div>
        <span className="muted" style={{ marginTop: "12px", textAlign: "center", fontSize: "12px", lineHeight: "17px" }}>Lowering your limit works instantly. Raising it takes 24 hours to kick in. Withdrawals always work.</span>
        <div style={{ marginTop: "auto", paddingTop: "14px", display: "flex", flexDirection: "column", gap: "10px", flexShrink: 0 }}>
          <button onClick={() => go("App09", true)} className="btnP">SEE YOU TOMORROW</button>
          <button onClick={() => go("App58")} className="btnS">Change my limit</button>
        </div>
      </div>
    </div>
  );
}
